import DataQualityDashboard from './DataQualityDashboard';
export default DataQualityDashboard;
